// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;

export function register(config) {
  //production
  if ("serviceWorker" in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // console.log("register", { env: process.env });
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `/sw.js`;
      registerValidSW(swUrl, config);
    });
  }
}

function stateChangeHandler(installingWorker, config) {
  installingWorker.postMessage({
    type: "STATE_CHANGE",
    status: installingWorker.state,
  });
  if (installingWorker.state === "installed") {
    if (navigator.serviceWorker.controller) {
      installingWorker.postMessage({ type: "SKIP_WAITING" });
      // Execute callback
      if (config && config.onUpdate) {
        config.onUpdate(installingWorker);
      }
    } else {
      // Execute callback
      if (config && config.onSuccess) {
        config.onSuccess(installingWorker);
      }
    }
    return;
  }
  if (installingWorker.state === "activate") {
    if (navigator.serviceWorker.controller) {
      installingWorker.postMessage({ type: "CLAIM_CLIENTS" });
    }
    return;
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl, { scope: "/" })
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () =>
          stateChangeHandler(installingWorker, config);
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

// function checkValidServiceWorker(swUrl, config) {
//   // Check if the service worker can be found. If it can't reload the page.
//   fetch(swUrl, {
//     headers: { "Service-Worker": "script" },
//   })
//     .then((response) => {
//       // Ensure service worker exists, and that we really are getting a JS file.
//       const contentType = response.headers.get("content-type");
//       if (
//         response.status === 404 ||
//         (contentType != null && contentType.indexOf("javascript") === -1)
//       ) {
//         // No service worker found. Probably a different app. Reload the page.
//         navigator.serviceWorker.ready.then((registration) => {
//           registration.unregister().then(() => {
//             window.location.reload();
//           });
//         });
//       } else {
//         // Service worker found. Proceed as normal.
//         registerValidSW(swUrl, config);
//       }
//     })
//     .catch(() => {
//       console.log(
//         "No internet connection found. App is running in offline mode."
//       );
//     });
// }

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log("service workers unRegistered");
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
